import {
  AddIcon,
  Box,
  Divider,
  HStack,
  Pressable,
  ScrollView,
  Text,
  VStack,
  CloseIcon,
  Button,
  Image,
  Input,
  IconButton,
} from "native-base";
import React, {
  FC,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import Tooltip from "@mui/material/Tooltip";
import AVCancel from "../../components/common/AVCancel";
import AVEmoji from "../../components/common/AVEmoji";
import { StyleSheet } from "react-native";
import * as AV from "../../AVCore/AVCore";
import {
  VideoIcon,
  ExpandIcon,
  CollapseIcon,
  DropdownIcon,
  BrushIcon,
  ImportBGImage,
  CancelIcon,
  FormattingIcon,
  PlainTextIcon,
  CircleSlashIcon,
  BoostIcon,
} from "../../assets/icons/icon-assets";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import { Loc } from "../../App/Loc";
import { Media, Post, Person } from "../../AVCore/AVCore";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setFeeds } from "../../Redux/Actions/feedsAction";
import { v4 as uuidv4 } from "uuid";
import AVEmojiPicker from "../../components/common/AVEmojiPicker";
import {
  setisActive,
  setPostPopupExpanded,
  setUser,
  setEntitydata,
} from "../../Redux/Actions/userActions";
import AVInputtext from "../../components/AVInputtext";
import LinkPreview from "./preview/LinkPreview";
import CustomToast from "../../Hooks/useCustomToast";
import useDrivePicker from "react-google-drive-picker";
import Webcam from "react-webcam";
import { FiCamera, FiVideo } from "react-icons/fi";
import axios from "axios";
import ExternalLink from "./ExternalLink";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import type SunEditorCore from "suneditor/src/lib/core";
import type { Plugin } from "suneditor/src/plugins/Plugin";
import { SketchPicker } from "react-color";
import CreatePostGrid from "../../Screens/Home/CreatePostGrid";
import AVBoostPostPopup from "../../components/common/AVBoostPostPopup";
import PurchaseCreditsPopup from "../../components/common/PurchaseCreditsPopup";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";

interface Props {
  visibilityPermission: string;
  setShowCreatePost: any;
  Postdata: any;
  type: string;
  setFeedChunks: any;
  feedChunks: any;
  onEmojiClick?: (
    emojiObject: { native: string },
    isFormattedPost: boolean,
    rteValue?: string,
  ) => void;
  handleAddComment: any | undefined;
  handlePostComment: any | undefined;
  showAddComment: any | false;
  setShowAddComment: any | undefined;
  setCommentMedia: any | undefined;
  isHuddlePostTab: any | false;
  boostPostOwner: AV.IFK | undefined;
  paySend: number;
  setPaySend: Dispatch<SetStateAction<number>>;
  subject: string;
  setSubject: Dispatch<SetStateAction<string>>;
  estimate: number | null;
  setEstimate: Dispatch<SetStateAction<number | null>>;
  showBoostPostPopup: boolean;
  setShowBoostPostPopup: Dispatch<SetStateAction<boolean>>;
  showCreditsPopup: boolean;
  setShowCreditsPopup: Dispatch<SetStateAction<boolean>>;
  estimateVisibility?: string;
  sharedPlan?: AV.ISharedPlan;
  setSharedPlan?: (plan: AV.ISharedPlan) => void;
}

const AVPostPopup: FC<Props> = ({
  setShowCreatePost,
  Postdata,
  type,
  visibilityPermission,
  setFeedChunks,
  feedChunks,
  onEmojiClick,
  handleAddComment,
  handlePostComment,
  showAddComment,
  setShowAddComment,
  setCommentMedia,
  isHuddlePostTab,
  boostPostOwner,
  paySend,
  setPaySend,
  subject,
  setSubject,
  estimate,
  setEstimate,
  showBoostPostPopup,
  setShowBoostPostPopup,
  showCreditsPopup,
  setShowCreditsPopup,
  estimateVisibility,
  sharedPlan,
  setSharedPlan,
}) => {
  const dispatch = useDispatch();
  const dimensions = useWindowDimension();
  const textRef = useRef<any>(null);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const userfeeds = useSelector(
    (state: RootStateOrAny) => state.feeds.feeds[0],
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );

  const [media, setMedia] = useState<any>([]);
  const [Img, setImg] = useState<any>([]);
  const [video, setvio] = useState<any>([]);
  const [link, setLink] = useState<any>([]);
  const [oneDriveLink, setOneDriveLink] = useState<any>([]);
  const [picker, setPicker] = useState(false);
  const [text, setText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isImageProcessing, setIsImageProcessing] = useState(false);
  const isStaffOfEntity = Postdata?.staff?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isCurrentUser = Postdata?.id === currentUser?.id;
  const isOwner = isStaffOfEntity || isCurrentUser;
  const [alertMessage, setAlertMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showExternalLinkInput, setShowExternalLinkInput] = useState(false);
  const [externalLink, setExternalLink] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  const isValidLink =
    /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;

  const isSpecialPost =
    Postdata?.id === "78b5b063-fd3e-4925-92bd-2a1888c6a46a" ||
    Postdata?.parent?.id === "78b5b063-fd3e-4925-92bd-2a1888c6a46a";

  const getVisibilityLabel = () => {
    if (isStaffOfEntity) {
      return Loc.currentLang.menu.private;
    }

    if (isSpecialPost) {
      return Loc.currentLang.menu.public;
    }

    if (visibilityPermission === "F") {
      return Loc.currentLang.menu.followers;
    }

    if (visibilityPermission === "B") {
      //// If it's not the current user, still show followers
      //return !isCurrentUser
      //  ? Loc.currentLang.menu.followers
      //  : Loc.currentLang.menu.public;
      return Loc.currentLang.menu.followers;
    }

    return Loc.currentLang.menu.private;
  };
  const [visibility, setVisibility] = useState(getVisibilityLabel());
  const visibilityMap: Record<string, string> = {
    [Loc.currentLang.menu.public]: "Public",
    [Loc.currentLang.menu.private]: "Private",
    [Loc.currentLang.menu.followers]: "Follow",
    [Loc.currentLang.menu.organizations]: "Org",
  };

  const [isActive, setIsActive] = useState(false);
  const isMobile = dimensions?.width <= 500 || false;
  const [addLinkLoad, setAddLinkLoad] = useState(false);
  const [isOpenBox, setIsOpenBox] = useState(false);
  const [openPicker, authResponse] = useDrivePicker();
  const newGuid = uuidv4();
  const camera = useRef<any>(null);
  const [isOpenCemera, setIsOpenCemera] = useState<any>(false);
  const [isYoutube, setIsYouTube] = useState<any>(false);
  const [isOnedriveData, setIsOneDriveData] = useState<any>("");
  const [isCameraAccessible, setIsCameraAccessible] = useState(true);
  const [pdf, setpdf] = useState<any>([]);
  const [showPreview, setShowPreview] = useState(false);
  const [singleImage, setSingleImage] = useState();
  const [allImages, setShowAllImage] = useState([]);
  const [allMedia, setAllMedia] = useState<any>([]);

  // Confirmation Popup
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>("");

  const [isOwnerOfBoost, setIsOwnerOfBoost] = useState(false);
  const [boostPostCreditsOwner, setBoostPostCreditsOwner] = useState<AV.IFK>();

  useEffect(() => {
    if (!currentUser /* || isStaffOfEntity*/ || showAddComment) return;

    const setOwner = async (entity: AV.IFK | null) => {
      if (!entity) {
        setIsOwnerOfBoost(false);
        return;
      }

      const canShare = await checkShareTypeCase(entity);

      if (canShare) {
        setIsOwnerOfBoost(true);
        setBoostPostCreditsOwner(entity);
      } else {
        setIsOwnerOfBoost(false);
      }
    };

    const getOwnerFk = (entity: any) => AV.AVEntity.getFk(entity);

    const isOwnerOrStaff = (roleName?: string) =>
      roleName === "Owner" || roleName === "Staff";

    const checkParticipants = () => {
      return (
        Postdata?.participants?.some(
          (p) => p?.id === currentUser?.id && isOwnerOrStaff(p?.linkType),
        ) || false
      );
    };

    const checkEventOrChannelCase = async () => {
      const isChannelWithParent =
        boostPostOwner?.type === "Channel" ||
        (Postdata?.type === "Channel" && Postdata?.parent);
      const isEventOwner =
        (Postdata?.owner?.type === "Event" ||
          Postdata?.owner?.type === "Game") &&
        Postdata?.topOwner?.type !== "Person";

      const isEventOrChannelCase = showAddComment
        ? isEventOwner || isChannelWithParent || !!boostPostOwner?.id
        : isChannelWithParent;

      if (!isEventOrChannelCase) return false;

      let ownerEntity = boostPostOwner
        ? boostPostOwner?.type === "Channel" && Postdata?.id
          ? (Postdata?.topOwner ?? Postdata?.parent ?? boostPostOwner)
          : boostPostOwner
        : (Postdata?.topOwner ?? Postdata?.parent);
      if (!ownerEntity) return false;

      // Try from local list
      let evtEntity =
        entityDataList?.find((x) => x?.id === ownerEntity?.id) ?? null;

      if (
        (evtEntity?.type === "Event" || evtEntity?.type === "Channel") &&
        (!evtEntity.staff || evtEntity.staff.length === 0) &&
        evtEntity.parent
      ) {
        ownerEntity = evtEntity?.parent;
        evtEntity =
          entityDataList?.find((x) => x?.id === evtEntity?.parent?.id) ?? null;
      }

      // Otherwise fetch
      if (!evtEntity) {
        evtEntity = await AV.AVEntity.get(ownerEntity);
        if (evtEntity) {
          entityDataList?.push(evtEntity);
          dispatch(setEntitydata(entityDataList));
        }
      }

      if (evtEntity?.type !== "Person") {
        return evtEntity?.staff?.some(
          (s) => s?.id === currentUser?.id && isOwnerOrStaff(s?.role?.name),
        );
      }

      if (evtEntity?.type === "Person" && Postdata?.name?.includes("Friends")) {
        return (
          Postdata?.parent?.id === currentUser?.id
          //|| evtEntity.members?.some((m) => m?.id === currentUser?.id)
        );
      }

      return false;
    };

    const checkPersonTopOwnerCase = () => {
      if (!Postdata?.participants && Postdata?.topOwner?.type === "Person") {
        return Postdata?.topOwner?.id === currentUser?.id;
      }
      return false;
    };

    const checkPersonProfileCase = () => {
      if (
        !["Person", "Pet"].includes(Postdata?.type) ||
        (boostPostOwner &&
          !["Person", "Pet"].includes(boostPostOwner?.type ?? ""))
      )
        return false;

      // Self Profile
      if (Postdata?.id === currentUser?.id) return true;

      if (
        Postdata?.type === "Person" ||
        (boostPostOwner && boostPostOwner?.type === "Person")
      )
        return true;

      // Combined related list
      const combined = [
        ...(currentUser?.orgs ?? []),
        ...(currentUser?.follows ?? []),
        ...(currentUser?.guardians ?? []),
        ...(currentUser?.members ?? []),
        ...(currentUser?.wards ?? []),
      ];

      const unique = [...new Map(combined.map((i) => [i.id, i])).values()];

      // If Postdata.id not in related list → user owns Postdata
      return !unique.some((x) => x?.id === Postdata?.id);
    };

    const checkShareTypeCase = async (
      entity: AV.IAVEntity | AV.IFK,
    ): Promise<boolean> => {
      let resolvedEntity: AV.IAVEntity | null = null;

      if ("plan" in entity) {
        resolvedEntity = entity;
      } else {
        resolvedEntity =
          entityDataList?.find((x) => x?.id === entity?.id) ?? null;

        if (!resolvedEntity) {
          resolvedEntity = await AV.AVEntity.get(entity);
          if (resolvedEntity) {
            dispatch(
              setEntitydata([...(entityDataList ?? []), resolvedEntity]),
            );
          }
        }
      }

      if (!resolvedEntity?.plan?.shared) return true;

      try {
        let shared =
          entityDataList?.find(
            (x) => x?.id === resolvedEntity!.plan!.shared!.id,
          ) ?? null;

        if (!shared) {
          shared = await AV.AVEntity.getSharedPlan(
            AV.AVEntity.getFk(resolvedEntity),
          );
          dispatch(setEntitydata([...(entityDataList ?? []), shared]));
        }

        setSharedPlan?.(shared);

        return !(
          shared?.owner?.id !== entity?.id && shared?.autoShareType === "NB"
        );
      } catch (e) {
        console.error("Failed to load shared plan:", e);
        return false;
      }
    };

    const checkBoostOwner = async () => {
      // 1. No Postdata, Create Post in Home screen
      if (!Postdata) {
        setOwner(getOwnerFk(currentUser));
        return;
      }

      // 2. Check participants
      if (checkParticipants()) {
        setOwner(getOwnerFk(Postdata?.topOwner ?? Postdata?.parent));
        return;
      }

      // 3. Event / Channel staff and friends channel owner check
      const eventOwner = await checkEventOrChannelCase();
      if (eventOwner) {
        setOwner(getOwnerFk(Postdata?.topOwner ?? Postdata?.parent));
        return;
      }

      // 4. Person topOwner with no participants
      if (checkPersonTopOwnerCase()) {
        setOwner(getOwnerFk(Postdata?.topOwner));
        return;
      }

      // 5. Person profile & home post
      if (checkPersonProfileCase()) {
        setOwner(getOwnerFk(Postdata));
        return;
      }

      // 6. Entity Owner or Staff
      if (isStaffOfEntity) {
        setOwner(getOwnerFk(Postdata));
        return;
      }

      // Default fallback
      setIsOwnerOfBoost(false);
    };

    checkBoostOwner();
  }, [Postdata, showAddComment]);

  // RichTextEditor(Formatting Post)
  const editorRef = useRef<SunEditorCore | null>(null);
  const [useRichText, setUseRichText] = useState(false);
  const [rteValue, setRteValue] = useState("");
  const customFonts = [
    "Arial",
    "Calibri",
    "Cambria",
    "Candara",
    "Comic Sans MS",
    "Consolas",
    "Constantia",
    "Corbel",
    "Courier New",
    "Georgia",
    "Impact",
    "Lucida Console",
    "Lucida Sans Unicode",
    "Palatino Linotype",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Tahoma",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
  ];
  const customLang: any = {
    code: currentUser?.preferences?.lang ?? "en",
    toolbar: Loc.currentLang.richText.toolbar,
    dialogBox: {
      linkBox: Loc.currentLang.richText.linkBox,
      imageBox: Loc.currentLang.richText.imageBox,
      videoBox: Loc.currentLang.richText.videoBox,
      audioBox: Loc.currentLang.richText.audioBox,
    },
    controller: Loc.currentLang.richText.controller,
    menu: {},
  };
  const toolbarOptions = {
    buttonList: [
      ["font", "fontSize"],
      ["fontColor", "hiliteColor"],
      ["bold", "italic", "underline", "strike"],
      ["align", "list"],
      ["link", "image"],
      ["undo", "redo"],
    ],
    //height: "152px",
    //minHeight: "152px",
    //maxHeight: "152px",
    showPathLabel: false,
    //resizingBar: false,
    defaultStyle: "font-family: Arial; font-size: 16px;",
    placeholder: Loc.currentLang.postPopup.shareWhatIsOnYourMind,
    font: customFonts,
    fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 64, 128],
  };

  const [bgColor, setBgColor] = useState<string>("");
  const [bgImage, setBgImage] = useState<string>("");
  const [bgImgWidth, setBgImgWidth] = useState<string>("");
  const [bgImgHeight, setBgImgHeight] = useState<string>("");
  const [showBgImgMenu, setShowBgImgMenu] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorInputRef = useRef<HTMLInputElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const editorContainerRef = useRef<HTMLDivElement | null>(null);
  const colorPickerRef = useRef<HTMLDivElement | null>(null);
  const bgImgMenuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(e.target as Node)
      ) {
        setShowBgImgMenu(false);
        setShowColorPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        bgImgMenuRef.current &&
        !bgImgMenuRef.current.contains(event.target as Node)
      ) {
        setShowBgImgMenu(false);
        setShowColorPicker(false);
      }
    };

    if (showBgImgMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showBgImgMenu]);

  useEffect(() => {
    if (editorRef.current && useRichText) {
      const editableArea = document.querySelector<HTMLDivElement>(
        ".sun-editor-editable",
      );

      if (editableArea) {
        if (bgImgHeight && bgImgWidth) {
          editableArea.style.height = `${bgImgHeight}px`;
          editableArea.style.minHeight = `${bgImgHeight}px`;
          editableArea.style.width = `${bgImgWidth}px`;
          editableArea.style.minWidth = `${bgImgWidth}px`;
        } else {
          editableArea.style.height = isExpanded ? "54vh" : "20vh";
        }
      }
    }
  }, [isExpanded]);

  useEffect(() => {
    if (editorRef.current && useRichText && bgColor.trim().length > 0) {
      const editableArea = document.querySelector<HTMLDivElement>(
        ".sun-editor-editable",
      );

      if (editableArea) {
        editableArea.innerHTML = editableArea.innerHTML
          .replace(/background-color:\s*#[0-9A-Fa-f]{3,6};?/g, "")
          .replace(/<div[^>]*>([\s\S]*?)<\/div>/g, "$1");

        editableArea.style.backgroundImage = "unset";
        editableArea.style.backgroundSize = "unset";
        editableArea.style.backgroundPosition = "unset";
        editableArea.style.backgroundRepeat = "unset";
        editableArea.style.height = isExpanded ? "54vh" : "20vh";
        editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
        editableArea.style.width = "unset";
        editableArea.style.minWidth = "unset";

        editableArea.style.backgroundColor = bgColor;
      }
    }
  }, [isOpenCemera, showExternalLinkInput]);

  //useEffect(() => {
  //  document.body.style.overflow = "hidden";
  //}, []);

  const handleColorChange = (color: any) => {
    setBgImage("");
    setBgImgWidth("");
    setBgImgHeight("");
    setBgColor(color.hex);

    const editableArea = document.querySelector<HTMLDivElement>(
      ".sun-editor-editable",
    );
    if (editableArea) {
      // Remove any inline background-color or wrapper divs
      editableArea.innerHTML = editableArea.innerHTML
        // Remove inline background-color styles
        .replace(/background-color:\s*#[0-9A-Fa-f]{3,6};?/g, "")
        // Remove redundant wrapping <div style=""> if empty
        .replace(/<div[^>]*>([\s\S]*?)<\/div>/g, "$1");

      // Reset editor area styling
      editableArea.style.backgroundImage = "unset";
      editableArea.style.backgroundSize = "unset";
      editableArea.style.backgroundPosition = "unset";
      editableArea.style.backgroundRepeat = "unset";
      editableArea.style.height = isExpanded ? "54vh" : "20vh";
      editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
      editableArea.style.width = "unset";
      editableArea.style.minWidth = "unset";

      editableArea.style.backgroundColor = color.hex;
    }
  };

  const handleToggleRichTextPost = () => {
    setUseRichText((prev) => {
      const newValue = !prev;
      //if (!showBoostPostPopup) handleToggleRichTextSubject();

      setTimeout(() => {
        if (newValue) {
          // --- Switching TO Rich Text ---
          if (text && !/<[a-z][\s\S]*>/i.test(text)) {
            const formattedText = `<p>${text}</p>`;
            setRteValue(formattedText);

            const editor = editorRef.current;
            if (editor) {
              editor.setContents(formattedText);
              const editableArea = editor.core?.context?.element?.wysiwyg;
              if (editableArea && !showBoostPostPopup) {
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(editableArea);
                range.collapse(false); // Move cursor to end
                selection?.removeAllRanges();
                selection?.addRange(range);
              }
            }
          }
        } else {
          // --- Switching TO Plain Text ---
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = rteValue;
          const plain = (tempDiv.innerText || "")
            .trim()
            .replace(/[\u200B-\u200D\uFEFF]/g, "");
          setText(plain);

          // Move cursor to end in textarea
          setTimeout(() => {
            if (textRef.current) {
              const textarea = textRef.current;
              if (!showBoostPostPopup) textarea.focus();
              textarea.selectionStart = textarea.selectionEnd =
                textarea.value.trim().length;
            }
          }, 100);

          // Reset background styles
          setBgColor("");
          setBgImage("");
          setBgImgWidth("");
          setBgImgHeight("");

          const editableArea = document.querySelector<HTMLDivElement>(
            ".sun-editor-editable",
          );
          if (editableArea) {
            editableArea.style.backgroundImage = "unset";
            editableArea.style.backgroundSize = "unset";
            editableArea.style.backgroundPosition = "unset";
            editableArea.style.backgroundRepeat = "unset";
            editableArea.style.backgroundColor = "unset";

            editableArea.style.height = isExpanded ? "54vh" : "20vh";
            editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
            editableArea.style.width = "unset";
            editableArea.style.minWidth = "unset";
          }
        }
      }, 200); // small delay for render sync

      return newValue;
    });
  };

  const handleToggleRichTextSubject = () => {
    setUseRichText((prev) => {
      const newValue = !prev;
      if (showBoostPostPopup) handleToggleRichTextPost();

      setTimeout(() => {
        if (newValue) {
          // Switching TO Rich Text
          if (subject && !/<[a-z][\s\S]*>/i.test(subject)) {
            const formattedText = `<p>${subject}</p>`;
            setSubject(formattedText);

            const editor = editorRef.current;
            if (editor) {
              editor.setContents(formattedText);
              const editableArea = editor.core?.context?.element?.wysiwyg;
              if (editableArea) {
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(editableArea);
                range.collapse(false); // move cursor to end
                selection?.removeAllRanges();
                selection?.addRange(range);
              }
            }
          }
        } else {
          // Switching TO Plain Text
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = subject;
          const plain = (tempDiv.innerText || "")
            .trim()
            .replace(/[\u200B-\u200D\uFEFF]/g, "");
          setSubject(plain);

          // Remove backgroundImage and backgroundColor
          setBgColor("");
          setBgImage("");
          setBgImgWidth("");
          setBgImgHeight("");

          const editableArea = document.querySelector<HTMLDivElement>(
            ".sun-editor-editable",
          );
          if (editableArea) {
            editableArea.style.backgroundImage = "unset";
            editableArea.style.backgroundSize = "unset";
            editableArea.style.backgroundPosition = "unset";
            editableArea.style.backgroundRepeat = "unset";
            editableArea.style.backgroundColor = "unset";
            editableArea.style.width = "unset";
            editableArea.style.minWidth = "unset";
          }
        }
      }, 200); // small delay for render sync

      return newValue;
    });
  };

  function autoSetImageSize() {
    // File input
    const fileInput =
      document.querySelector<HTMLInputElement>("._se_image_file");
    if (fileInput) {
      fileInput.addEventListener("change", (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file) {
          const img = new window.Image();
          img.onload = () => {
            document.querySelector<HTMLInputElement>(
              "._se_image_size_x",
            )!.value = String(img.width);
            document.querySelector<HTMLInputElement>(
              "._se_image_size_y",
            )!.value = String(img.height);
          };
          img.src = URL.createObjectURL(file);
        }
      });
    }

    // URL input
    const urlInput = document.querySelector<HTMLInputElement>("._se_image_url");
    if (urlInput) {
      urlInput.addEventListener("blur", () => {
        if (urlInput.value) {
          const img = new window.Image();
          img.onload = () => {
            document.querySelector<HTMLInputElement>(
              "._se_image_size_x",
            )!.value = String(img.width);
            document.querySelector<HTMLInputElement>(
              "._se_image_size_y",
            )!.value = String(img.height);
          };
          img.src = urlInput.value;
        }
      });
    }
  }

  // camera
  const [cameraMode, setCameraMode] = useState<"photo" | "video">("photo");
  const [recording, setRecording] = useState(false);
  const [duration, setDuration] = useState(0);
  const recordedChunksRef = useRef<Blob[]>([]);
  const webcamRef = useRef<Webcam | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const durationRef = useRef<number | null>(null);
  const isCancelledRef = useRef(false);

  const formatDuration = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (recording) {
      durationRef.current = window.setInterval(() => {
        setDuration((prev) => prev + 1);
      }, 1000);
    } else {
      if (durationRef.current !== null) clearInterval(durationRef.current);
      setDuration(0);
    }

    return () => {
      if (durationRef.current !== null) clearInterval(durationRef.current);
    };
  }, [recording]);

  const handleExternalLink = (e) => {
    setExternalLink(e.target.value);
  };

  function base64ToFile2(base64: string, filename: string): File {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const handleImages = async (e: any) => {
    // No need to compress images or videos in the web app — only in the native app.
    setAlertMessage("");
    const fileInput: any = imageInputRef.current;
    let files: any = Array.from(e?.target?.files);

    const updatedFiles = files.map((file: any) => {
      const fileName = file.name;
      if (fileName.toLowerCase().endsWith(".jfif")) {
        const updatedFileName = fileName.replace(/\.\w+$/, ".jpg");
        const updatedFile = new File([file], updatedFileName, {
          type: "image/jpeg",
        });
        return updatedFile;
      } else {
        return file;
      }
    });
    files = updatedFiles;

    let m = "";
    if (files.length > 20) {
      m = Loc.currentLang.postPopup.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    setPicker(false);

    files.forEach((img: any) => {
      if (
        img.type !== "image/jpeg" &&
        img.type !== "image/jfif" &&
        img.type !== "image/png" &&
        /*img.type !== "image/webp" &&*/
        img.type !== "image/gif" &&
        img.type !== "video/mp4" &&
        img.type !== "video/quicktime" &&
        img.type !== "audio/mpeg"
      ) {
        m =
          Loc.currentLang.postPopup
            .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
        files = files.filter((item: any) => item.name !== img.name);
        setAlertMessage(m);
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(img);
      }
    });

    setIsImageProcessing(true);
    console.log(files);

    if (files?.length > 0) {
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(files),
        currentUser?.region,
      );

      if (data[0]?.status == "Invalid Size") {
        setAlertMessage(Loc.currentLang.alertMessages.largeVideo);
        fileInput.value = null;
        setIsImageProcessing(false);

        return;
      }

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);
        if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

        if (data?.length > 0) {
          data.forEach((img) => {
            if (img?.type?.startsWith("image"))
              setImg((images) => [...images, img]);
            else setvio((videos) => [...videos, img]);
          });
        }
      }
    }

    fileInput.value = null;
    setIsImageProcessing(false);
  };

  // Utility to convert File[] to FileList
  function createFileList(files: File[]): FileList {
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    return dataTransfer.files;
  }

  const handleCameraPhotoCapture = async () => {
    setAlertMessage("");
    setIsOpenCemera(false);

    if (!webcamRef.current) {
      console.error("Webcam not available");
      return;
    }

    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      console.error("Failed to capture image from webcam");
      return;
    }

    let file = base64ToFile2(imageSrc, "captured-image.jpg");

    // Limit file count
    const files: File[] = [file];
    if (files.length > 20) {
      const m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang?.postPopup?.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    // UI State
    setPicker(false);
    setIsImageProcessing(true);

    // Preview file
    const reader = new FileReader();
    reader.readAsDataURL(file);

    try {
      const fileList = createFileList(files);
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        currentUser?.region,
      );

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);
        if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

        data.forEach((item) => {
          setImg((prev) => [...prev, item]);
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setAlertMessage("Upload failed. Please try again.");
    } finally {
      setIsImageProcessing(false);
      onClose();
    }
  };

  const handleCameraVideoCapture = async (chunks: Blob[]) => {
    setAlertMessage("");
    setIsOpenCemera(false);

    const blob = new Blob(chunks, { type: "video/webm" });
    const file = new File([blob], "recorded-video.webm", {
      type: "video/webm",
    });

    const files: File[] = [file];
    if (files.length > 20) {
      const m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang?.postPopup?.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    setPicker(false);
    setIsImageProcessing(true);

    const reader = new FileReader();
    reader.readAsDataURL(file);

    try {
      const fileList = createFileList(files);
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        currentUser?.region,
      );

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);
        if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

        data.forEach((item) => {
          setvio((prev) => [...prev, item]);
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setAlertMessage("Upload failed. Please try again.");
    } finally {
      if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();
        setRecording(false);
      }
      setIsImageProcessing(false);
      onClose();
    }
  };

  const handleStartRecording = () => {
    setAlertMessage("");
    recordedChunksRef.current = [];

    const stream = webcamRef.current?.stream;

    if (!stream) {
      console.error("Webcam stream not available");
      return;
    }

    const mediaRecorder = new MediaRecorder(stream, {
      mimeType: "video/webm; codecs=vp9",
    });

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        recordedChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      if (!isCancelledRef.current) {
        handleCameraVideoCapture(recordedChunksRef.current);
      } else {
        isCancelledRef.current = false; // reset flag for future recordings
      }
    };

    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.start();
    setRecording(true);
  };

  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  const toggleMode = () => {
    if (recording) {
      isCancelledRef.current = true; // mark that we're switching mode and canceling recording
      handleStopRecording();
    }

    setCameraMode((prev) => (prev === "photo" ? "video" : "photo"));
  };

  const onClose = () => {
    setIsOpenCemera(false);
    setRecording(false);
    setDuration(0);
    setCameraMode("photo");
    if (durationRef.current !== null) clearInterval(durationRef.current);
  };

  const handleCamera = async (e: any) => {
    setAlertMessage("");
    setIsOpenCemera(false);
    const fileInput: any = camera.current.takePhoto();
    const file: any = base64ToFile2(fileInput, "captured-image.jpg");
    let files: any = [];
    files?.push(file);
    const updatedFiles = files.map((file: any) => {
      const fileName = file.name;
      if (fileName.toLowerCase().endsWith(".jfif")) {
        const updatedFileName = fileName.replace(/\.\w+$/, ".jpg");
        const updatedFile = new File([file], updatedFileName, {
          type: "image/jpeg",
        });
        return updatedFile;
      } else {
        return file;
      }
    });
    files = updatedFiles;
    let m = "";

    if (files.length > 20) {
      m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang.postPopup.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    setPicker(false);
    files.forEach((img: any) => {
      if (
        img.type !== "image/jpeg" &&
        img.type !== "image/jfif" &&
        img.type !== "image/png" &&
        /*img.type !== "image/webp" &&*/
        img.type !== "image/gif" &&
        img.type !== "video/mp4" &&
        img.type !== "video/quicktime"
      ) {
        m =
          Loc.currentLang.postPopup
            .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
        files = files.filter((item: any) => item.name !== img.name);
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(img);
      }
    });
    setIsImageProcessing(true);
    console.log(files);
    const data = await AV.Media.saveFiles(
      AV.Media.getFormData(files),
      currentUser?.region,
    );
    if (data?.length > 0) {
      setMedia((prev) => [...prev, ...data]);
      if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

      if (data?.length > 0) {
        data.forEach((img) => {
          if (img?.type?.startsWith("image"))
            setImg((images) => [...images, img]);
          else setvio((videos) => [...videos, img]);
        });
      }
    }
    //fileInput.value = null;
    setIsImageProcessing(false);
  };

  // Replace all base64 images in HTML with uploaded URLs
  async function replaceBase64WithLinks(
    html: string,
    region: string,
  ): Promise<string> {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const imgTags = tempDiv.querySelectorAll("img");

    for (const img of imgTags) {
      const src = img.getAttribute("src");
      const imgStyle = img.getAttribute("style") || "";

      // Process only valid Base64 images
      if (!src || !src.startsWith("data:image")) continue;

      // Convert Base64 to File
      const file = base64ToFile2(src, "upload-image.jpg");
      if (!file) continue;

      // Convert to FileList
      const fileList = createFileList([file]);

      // Upload file
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        region,
      );
      if (!data || data.length === 0) continue;

      // Get uploaded link
      const srclink = AV.Media.getURL(data[0]);
      if (!srclink) continue;

      // Set metadata before saving
      data[0].parent = AV.AVBase.getFk(Person.self());
      //data[0].linkURL = srclink;

      // Save uploaded media
      await AV.Media.saveMedia(data);

      // Replace Base64 src with actual URL
      img.setAttribute("src", srclink);

      // Determine image width dynamically
      const tempImage = document.createElement("img");
      tempImage.src = src;

      await new Promise<void>((resolve) => {
        tempImage.onload = () => {
          // Extract width and height from style (if any)
          const widthMatch = imgStyle.match(/width:\s*(\d+)px/i);
          const heightMatch = imgStyle.match(/height:\s*(\d+)px/i);

          let styleWidth = widthMatch ? parseInt(widthMatch[1], 10) : undefined;
          let styleHeight = heightMatch
            ? parseInt(heightMatch[1], 10)
            : undefined;

          // Fallback to actual image size if no style width/height
          const width = styleWidth ?? tempImage.width;
          const height = styleHeight ?? tempImage.height;

          //// Apply max width constraint
          //const finalWidth = width > 775 ? 775 : width;
          //const finalHeight = height;

          //// Set final styles
          //img.setAttribute(
          //  "style",
          //  `width: ${finalWidth}px; height: ${finalHeight}px;`,
          //);

          resolve();
        };

        tempImage.onerror = () => resolve();
      });
    }

    return tempDiv.innerHTML;
  }

  const hasContent = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html || "";

    let text = tempDiv.textContent || "";
    text = text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();
    if (text.length > 0) return true; // has real text

    // Check if HTML contains <img> or <video> tags
    if (tempDiv.querySelector("img, video")) return true;

    return false;
  };

  const handlePublish = async () => {
    // Get the text depending on editor type
    let textContent = useRichText
      ? rteValue?.trim()
      : textRef?.current?.value?.trim() || "";
    let subContent = subject || "";

    // Validate: no text and no media
    if (!hasContent(textContent) && (!media || media.length === 0)) {
      setAlertMessage(Loc.currentLang.menu.emptyMediaErrorMsg);
      return;
    }

    // Validate: media limit
    if (media.length > 20) {
      setAlertMessage(Loc.currentLang.menu.limitExccedErrorMsg);
      return;
    }

    setAlertMessage("");
    setIsLoading(true);

    let param: AV.IFeedParam = {
      startDate: new Date(0),
      forward: true,
      checkArchive: false,
      feed: AV.AVBase.getFk(Postdata ? Postdata : Person.self()),
    };

    if (useRichText) {
      // Replace base64 images with uploaded links
      textContent = await replaceBase64WithLinks(
        textContent,
        currentUser?.region,
      );

      // Remove previous wrapper div with background styles
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = textContent;

      // If the top element is a div with inline style, unwrap it
      const firstChild = tempDiv.firstElementChild as HTMLElement | null;
      if (
        firstChild &&
        firstChild.tagName === "DIV" &&
        (firstChild.style.backgroundColor || firstChild.style.backgroundImage)
      ) {
        textContent = firstChild.innerHTML; // unwrap inner content
      }

      // Wrap content with the current background color/image
      if (bgColor || bgImage) {
        textContent = `<div style="
          ${bgColor ? `background-color: ${bgColor};` : ""}
          ${
            bgImage
              ? `
            background-image: url(${bgImage});
            background-size: contain;
            background-position: left;
            background-repeat: no-repeat;
            width: ${bgImgWidth ? `${bgImgWidth}px` : "auto"};
            height: ${bgImgHeight ? `${bgImgHeight}px` : "auto"};
          `
              : ""
          }
        ">${textContent}</div>`;
      }

      // Subject image
      subContent = await replaceBase64WithLinks(
        subContent,
        currentUser?.region,
      );

      //const tempSubDiv = document.createElement("div");
      //tempSubDiv.innerHTML = subContent;

      //const firstSubChild = tempSubDiv.firstElementChild as HTMLElement | null;
      //if (
      //  firstSubChild &&
      //  firstSubChild.tagName === "DIV" &&
      //  (firstSubChild.style.backgroundColor ||
      //    firstSubChild.style.backgroundImage)
      //) {
      //  subContent = firstSubChild.innerHTML;
      //}
    }

    if (param?.feed?.id) {
      let post: any = { pk: param?.feed?.id, region: param?.feed?.region };
      post.text = textContent;
      post.owner = AV.AVEntity.getFk(Postdata ? Postdata : Person.self());
      post.visibility = visibilityMap[visibility];
      post.paySend = textContent?.trim()?.length ? paySend : 0;
      post.subject =
        textContent?.trim()?.length && paySend > 0 ? subject : null;
      post.ptype = useRichText ? "H" : null;

      //// Attach metadata (parent + linkURL)
      //for (const mediaItem of media) {
      //  const srclink = AV.Media.getURL(mediaItem);
      //  if (!srclink) continue;
      //  mediaItem.parent = AV.AVEntity.getFk(Postdata ? Postdata : Person.self());
      //  mediaItem.linkURL = srclink;
      //}

      if (media && media.length === 1) {
        post.media = media[0];
        //if (media[0]?.linkURL) {
        //  post.text = media[0]?.orgFile?.startsWith("GoogleDrive")
        //    ? text !== null
        //      ? text
        //      : "" + "" + media[0]?.linkURL
        //    : text !== null
        //      ? text
        //      : "" + " " + media[0]?.orgFile;
        //}
      }

      if (media && media.length > 1) {
        let galleryPost: any[] = [];
        let gallery = { layout: null, Items: [] };
        post.gallery = gallery;
        post.id = newGuid;
        let parentPostId = newGuid;
        let galleryArray: string[] = [];

        for (var i = 0; i < media.length; i++) {
          let param1: AV.IFeedParam = {
            feed: AV.AVBase.getFk(Postdata ? Postdata : Person.self()),
            startDate: new Date(0),
            forward: true,
            checkArchive: false,
          };

          let post1: any = {
            pk: param1?.feed?.id,
            region: param1?.feed?.region,
          };

          post1.parentPost = parentPostId;
          post1.owner = AV.AVEntity.getFk(Postdata ? Postdata : Person.self());
          post1.media = media[i];
          post1.visibility = visibilityMap[visibility];
          post1.ptype = "G";
          let childresponse: any = await Post.save(post1);
          dispatch(setisActive(true));

          if (childresponse === Loc.currentLang.menu.inappropriateErrorMsg) {
            let clientError = {
              message: Loc.currentLang.menu.inappropriateErrorMsg,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }

          galleryArray.push(childresponse.id);
          galleryPost.push(childresponse);
        }

        post.status = "New";
        post.gallery.items = galleryArray;
        let val: any = await Post.save(post);
        dispatch(setisActive(true));

        if (val === Loc.currentLang.menu.inappropriateErrorMsg) {
          let clientError = {
            message: Loc.currentLang.menu.inappropriateErrorMsg,
          };
          CustomToast({ clientError });
          setIsLoading(false);
          return;
        }

        val.galleryPost = galleryPost;
        userfeeds.unshift(val);
        dispatch(setFeeds(userfeeds));
        setFeedChunks([val, ...feedChunks]);
        setMedia([]);
        if (showAddComment) setCommentMedia([]);

        setIsLoading(false);
        setShowCreatePost(false);
        dispatch(setPostPopupExpanded(false));

        if (paySend > 0 && boostPostCreditsOwner?.id) {
          setTimeout(() => {
            creditsUpdateAfterPublish();
          }, 500);
        }

        setPaySend(0);
        setSubject("");
        setEstimate(0);

        return;
      }

      let val: any = await AV.Post.save(post);
      dispatch(setisActive(true));

      if (val === Loc.currentLang.menu.inappropriateErrorMsg) {
        let clientError = {
          message: Loc.currentLang.menu.inappropriateErrorMsg,
        };
        CustomToast({ clientError });
        setIsLoading(false);
        return;
      }

      userfeeds.unshift(val);
      dispatch(setFeeds(userfeeds));
      setFeedChunks([val, ...feedChunks]); //prepend the new post to the feedChunks
      setMedia([]);
      if (showAddComment) setCommentMedia([]);

      setIsLoading(false);
      setSuccessMessage(Loc.currentLang.menu.postPublishSuccessMsg);
      setShowCreatePost(false);
      dispatch(setPostPopupExpanded(false));

      if (paySend > 0 && boostPostCreditsOwner?.id) {
        setTimeout(() => {
          creditsUpdateAfterPublish();
        }, 500);
      }

      setPaySend(0);
      setSubject("");
      setEstimate(0);
    }
  };

  const creditsUpdateAfterPublish = async () => {
    const entity: any = showAddComment
      ? Postdata?.type === "Person"
        ? currentUser
        : Postdata?.type === "Event" ||
            Postdata?.type === "Game" ||
            Postdata?.type === "Channel"
          ? Postdata?.parent
          : (Postdata ?? currentUser)
      : Postdata?.type === "Event" ||
          Postdata?.type === "Game" ||
          Postdata?.type === "Channel"
        ? Postdata?.parent
        : (Postdata ?? currentUser);
    const fk: AV.IFK = AV.AVEntity.getFk(entity ?? currentUser);
    let finalFk: AV.IFK = boostPostOwner ?? fk;
    if (boostPostOwner?.type === "Person") {
      finalFk =
        currentUser?.id !== boostPostOwner.id
          ? AV.AVEntity.getFk(currentUser)
          : boostPostOwner;
    }

    // Event use EVENT OWNER (parent)
    if (
      finalFk?.type === "Event" ||
      finalFk?.type === "Game" ||
      finalFk?.type === "Channel"
    ) {
      let parent: AV.ILink | null = null;

      if (entity?.parent) {
        parent = entity.parent;
      } else {
        const evtEntity =
          entityDataList?.find((x) => x?.id === entity.id) ?? null;

        if (evtEntity) {
          parent = evtEntity.parent ?? null;
        } else {
          const evtEntityAPI: AV.IAVEntity | null =
            await AV.AVEntity.get(finalFk);

          if (evtEntityAPI) {
            entityDataList?.push(evtEntityAPI);
            dispatch(setEntitydata(entityDataList));
            parent = evtEntityAPI.parent ?? null;
          }
        }
      }

      if (parent) {
        finalFk = parent;
      }
    }

    // Update current user credits
    if (
      finalFk?.id === currentUser?.id &&
      currentUser?.plan &&
      !currentUser?.plan?.shared
    ) {
      dispatch(
        setUser({
          ...currentUser,
          plan: {
            ...currentUser.plan,
            credits: (currentUser.plan.credits || 0) - (estimate ?? 0),
          },
        }),
      );
    }

    // Shared Plan
    if (sharedPlan && sharedPlan?.plan) {
      setSharedPlan?.({
        ...sharedPlan,
        plan: {
          ...sharedPlan.plan,
          credits: (sharedPlan.plan.credits || 0) - (estimate ?? 0),
        },
      });

      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === sharedPlan?.id);

      if (index !== -1) {
        const current = updatedList[index];

        updatedList[index] = {
          ...current,
          plan: {
            ...current?.plan,
            credits: (current?.plan?.credits || 0) - (estimate ?? 0),
          },
        };
      }

      dispatch(setEntitydata(updatedList));
    }

    // Update entity list credits
    if (
      finalFk?.id === currentUser?.id &&
      currentUser?.plan &&
      !currentUser?.plan?.shared
    ) {
      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === currentUser?.id);

      if (index !== -1) {
        const current = updatedList[index];

        updatedList[index] = {
          ...current,
          plan: {
            ...current?.plan,
            credits: (current?.plan?.credits || 0) - (estimate ?? 0),
          },
        };
      }

      dispatch(setEntitydata(updatedList));
    }

    //if (!boostPostCreditsOwner?.id) return;

    //try {
    //  const entityDataAPI: AV.IAVEntity | null = await AV.AVEntity.get(
    //    boostPostCreditsOwner,
    //  );

    //  if (entityDataAPI) {
    //    if (entityDataAPI.type === "Person") {
    //      dispatch(setUser(entityDataAPI));
    //    }

    //    const index = entityDataList?.findIndex(
    //      (x) => x?.id === entityDataAPI.id,
    //    );
    //    if (index !== -1) {
    //      entityDataList[index] = entityDataAPI;
    //    } else {
    //      entityDataList?.push(entityDataAPI);
    //    }

    //    dispatch(setEntitydata([...entityDataList]));
    //  }
    //} catch (e) {
    //  console.error("Failed to update entity after publish:", e);
    //}
  };

  function convertToEmbedLink(shareLink) {
    const url = new URL(shareLink);

    // Extract the video ID from the share link
    const videoId = url.pathname.split("/")[1];

    // Extract query parameters
    const queryParams = url.search;

    // Construct the embed link
    return `https://www.youtube.com/embed/${videoId}${queryParams}`;
  }

  const HandleAddExternalUrl = async () => {
    setAlertMessage("");
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    //let newLink = externalLink;
    let getExternalLinkType = isYoutube ? "iframe" : "linkPreview";
    let linkOfYoutube = "";
    //const youtubeUrl = isYouTubeURL( newLink );
    //const huddleUrl = isHuddleURL( newLink );
    //if ( youtubeUrl )
    //{
    //    newLink = youtubeUrl;
    //} else if ( huddleUrl )
    //{
    //    newLink = huddleUrl;
    //} else
    //{
    //    getExternalLinkType = getContentTypeFromUrl( newLink );
    //    console.log( getExternalLinkType );
    //}
    if (!isValidLink?.test(externalLink)) {
      let clientError = { message: "Invalid link format." };
      CustomToast({ clientError }); // Display error message using CustomToast
      setAddLinkLoad(false);
      setExternalLink("");
      setShowExternalLinkInput(false);
      setIsImageProcessing(false);
      return; // Exit the function early if the link format is invalid
    }
    let fd = new FormData();
    fd.append("linkURL", externalLink);
    const data = await AV.Media.saveFiles(fd, currentUser?.region);
    let response = await apiCall(externalLink);
    if (isYoutube) {
      linkOfYoutube = await convertToEmbedLink(externalLink);
    }
    data[0].linkURL = isYoutube ? linkOfYoutube : externalLink;
    data[0].orgFile =
      response?.image?.trim()?.length > 0
        ? response?.image
        : "https://cdn.pixabay.com/photo/2022/01/11/21/48/link-6931554_1280.png";
    data[0].type = getExternalLinkType;
    setMedia((prev) => [...prev, ...data]);
    if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

    //post.media = data[ 0 ];
    if (data?.length > 0) {
      data.forEach((img) => {
        setLink((link) => [...link, img]);
      });
    }
    setAddLinkLoad(false);
    setExternalLink("");
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  const HandleAddOneDrive = async () => {
    setAlertMessage("");
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);

    console.log("isOnedriveData data:", isOnedriveData);
    const mimeType = isOnedriveData?.type;
    const validTypes = [
      "image/jpeg",
      "image/jfif",
      "image/png",
      /*"image/webp",*/
      "image/gif",
      "video/mp4",
      "video/quicktime",
    ];

    if (!validTypes.includes(mimeType)) {
      let m =
        Loc.currentLang.postPopup
          .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
      setAddLinkLoad(false);
      setIsImageProcessing(false);
      setShowExternalLinkInput(false);
      setAlertMessage(m);
      return;
    }

    // Append the file blob
    const fd = new FormData();
    fd.append("file", isOnedriveData?.blob, isOnedriveData?.name);

    try {
      console.log("Form data: ", fd);
      const data = await AV.Media.saveFiles(fd, currentUser?.region);
      console.log("API response: ", data);

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);
        if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

        if (data?.length > 0) {
          data.forEach((img) => {
            if (img?.type?.startsWith("image"))
              setImg((images) => [...images, img]);
            else setvio((videos) => [...videos, img]);
          });
        }
      }
    } catch (err) {
      console.error("Error uploading to API", err);
      CustomToast({ clientError: { message: "Upload failed" } });
    }

    setAddLinkLoad(false);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
    setIsOneDriveData("");
  };

  const HandleAddDropBoxLink = async (link) => {
    setAlertMessage("");
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    for (let i = 0; i < link?.length; i++) {
      if (!isValidLink?.test(link[i]?.thumbnailLink)) {
        let clientError = { message: "Invalid link format." };
        CustomToast({ clientError }); // Display error message using CustomToast
        setAddLinkLoad(false);
        setExternalLink("");
        setShowExternalLinkInput(false);
        return; // Exit the function early if the link format is invalid
      }
      let fd = new FormData();
      fd.append("linkURL", link[i]?.thumbnailLink);
      const data = await AV.Media.saveFiles(fd, currentUser?.region);
      data[0].linkURL = link[i]?.link;
      data[0].orgFile = link[i]?.thumbnailLink;
      data[0].type = "dropbox";
      setMedia((prev) => [...prev, ...data]);
      if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

      if (data?.length > 0) {
        data.forEach((img) => {
          setOneDriveLink((oneDriveLink) => [...oneDriveLink, img]);
        });
      }
    }
    setAddLinkLoad(false);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  const HandleAddDocsLink = async (link) => {
    setAlertMessage("");
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    for (let i = 0; i < link?.length; i++) {
      if (!isValidLink?.test(link[i]?.embedUrl)) {
        let clientError = { message: "Invalid link format." };
        CustomToast({ clientError }); // Display error message using CustomToast
        setAddLinkLoad(false);
        setExternalLink("");
        setShowExternalLinkInput(false);
        return; // Exit the function early if the link format is invalid
      }
      let fd = new FormData();
      fd.append("linkURL", link[i]?.embedUrl);
      if (
        link[i]?.mimeType !== "image/jpeg" &&
        link[i]?.mimeType !== "image/jfif" &&
        link[i]?.mimeType !== "image/png" &&
        /*link[i]?.mimeType !== "image/webp" &&*/
        link[i]?.mimeType !== "image/gif" &&
        link[i]?.mimeType !== "video/mp4" &&
        link[i]?.mimeType !== "video/quicktime"
      ) {
        let m =
          Loc.currentLang.postPopup
            .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
        setAddLinkLoad(false);
        setShowExternalLinkInput(false);
        setIsImageProcessing(false);
        setAlertMessage(m);
        return;
      }
      const data = await AV.Media.saveFiles(fd, currentUser?.region);
      data[0].linkURL = link[i]?.embedUrl;
      data[0].orgFile = link[i]?.mimeType.startsWith("image")
        ? "GoogleDrive.jpg"
        : "GoogleDrive.mp4";
      data[0].type = "iframe";
      setMedia((prev) => [...prev, ...data]);
      if (showAddComment) setCommentMedia((prev) => [...prev, ...data]);

      //post.media = data[ 0 ];
      if (data?.length > 0) {
        data.forEach((img) => {
          setOneDriveLink((oneDriveLink) => [...oneDriveLink, img]);
        });
      }
    }
    setAddLinkLoad(false);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  const apiCall = async (url) => {
    try {
      const response = await axios.get("https://api.linkpreview.net", {
        params: {
          key: "fa7a7a675495a6cc97dac00c791ddb6b",
          q: url,
        },
      });
      // Check if response data exists
      if (response.data) {
        return response.data;
      } else {
        throw new Error("No data returned from API");
      }
    } catch (error) {
      setAddLinkLoad(false);
      setExternalLink("");
      setShowExternalLinkInput(false);
      setIsImageProcessing(false);
      let clientError = { message: "Invalid link format." };
      CustomToast({ clientError }); // Display error message using CustomToast
      console.error("Error fetching URL preview:", error);
      // Handle error appropriately (you could return a default value, throw error, etc.)
      throw new Error("Failed to fetch data from the API");
    }
  };

  const handleOpenPicker = () => {
    openPicker({
      clientId:
        "143407568263-uh85ecaqapgumtq787b2m3mu0l1sm0ve.apps.googleusercontent.com",
      developerKey: "AIzaSyCgz1ryXdQ2aDugOM1-dNHuz1Pavi1n230",
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.action === "cancel") {
          console.log("User clicked cancel/close button");
        }
        if (data?.action !== "loaded") {
          HandleAddDocsLink(data?.docs);
        }
      },
    });
  };

  const handleConfirmDelete = (item) => {
    setIsConfirmDelete(true);
    setConfirmationText(
      Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem,
    );
    setSelectedItem(item);
    setSelectedType("PostImageRemove");
  };

  const handleCancelImage = () => {
    setIsLoading(true);

    const filterById = (list) =>
      list?.filter((f) => f.id !== selectedItem.id) ?? [];

    setMedia(filterById(media));
    setImg(filterById(Img));
    setvio(filterById(video));
    setOneDriveLink(filterById(oneDriveLink));
    setAllMedia(filterById(allMedia));
    setLink(filterById(link));

    setIsLoading(false);
    setSelectedItem("");
    setSelectedType("");
    setConfirmationText("");
    setIsConfirmDelete(false);
  };

  useEffect(() => {
    console.log("useEffect isOnedriveData data:", isOnedriveData);
    let isMounted = true;

    const run = async () => {
      if (isOnedriveData?.blob !== undefined && isMounted) {
        await HandleAddOneDrive();
      }
    };

    run();

    return () => {
      isMounted = false;
    };
  }, [isOnedriveData]);

  const menuRefs = useRef(null);
  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActive(false);
          setPicker(false);
          setIsOpenBox(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const handleEmojiPicker = (e) => {
    const emoji = e?.native;

    // Insert emoji into RTE
    if (useRichText && editorRef.current) {
      editorRef.current.insertHTML(emoji);
    } else {
      // Insert emoji into plain text input
      const ref: any = textRef.current;
      ref.focus();

      const start = text?.substring(0, ref.selectionStart) || "";
      const end = text?.substring(ref.selectionStart) || "";
      const newText = start + emoji + end;

      setText(newText);
    }

    setPicker(!picker);
  };

  const mobile = dimensions?.width < 600 || false;

  useEffect(() => {
    let isMounted = true;

    async function checkCameraAccess() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });

        if (isMounted) {
          setIsCameraAccessible(true);
        }

        stream.getTracks().forEach((track) => track.stop()); // Clean up camera access
      } catch (err) {
        if (isMounted) {
          setIsCameraAccessible(false);
        }
      }
    }

    if (isOpenCemera) {
      checkCameraAccess();
    }

    return () => {
      isMounted = false;
    };
  }, [isOpenCemera]);

  const dropdownRef = useRef(null);
  useOutsideDropdownRef(dropdownRef, isActive, setIsActive);

  function useOutsideDropdownRef(ref, isActive, setIsActive) {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActive(false);
        }
      };

      if (isActive) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, isActive, setIsActive]);
  }

  return (
    <>
      {!showExternalLinkInput && !isOpenCemera && (
        <Box
          position="fixed"
          bgColor={"rgba(0, 0, 0, 0.25)"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              mobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isExpanded
                ? mobile
                  ? "100%"
                  : "90%"
                : mobile
                  ? dimensions.width - 15
                  : "700px",
              height: isExpanded ? (mobile ? "100%" : "90vh") : "60vh",
              maxHeight: isExpanded ? (mobile ? "100%" : "90vh") : "60vh",
              padding: isExpanded ? "30px" : "24px",
              top: isExpanded ? "50%" : "55%",
            }}
          >
            {picker && !mobile && (
              <Box
                position={"absolute"}
                ref={menuRefs}
                zIndex={99}
                borderColor={"#2FA3BE"}
                borderStyle={"solid"}
                borderWidth={"5px"}
                width={mobile ? "85%" : "88%%"}
              >
                <AVEmojiPicker
                  onEmojiSelect={(emojiObject) => {
                    if (showAddComment) {
                      onEmojiClick?.(
                        emojiObject,
                        useRichText,
                        editorRef.current?.getContents(true),
                      );
                    }
                    handleEmojiPicker(emojiObject);
                  }}
                />
              </Box>
            )}

            {picker && mobile && (
              <Box
                position={"fixed"}
                top={0}
                right={0}
                ref={menuRefs}
                zIndex={99}
                borderColor={"#2FA3BE"}
                borderStyle={"solid"}
                borderWidth={"5px"}
                width={"85%"}
              >
                <AVEmojiPicker
                  onEmojiSelect={(emojiObject) => {
                    if (showAddComment) {
                      onEmojiClick?.(
                        emojiObject,
                        useRichText,
                        editorRef.current?.getContents(true),
                      );
                    }
                    handleEmojiPicker(emojiObject);
                  }}
                />
              </Box>
            )}

            <VStack height={"100%"}>
              <HStack
                alignItems={"center"}
                justifyContent={"space-between"}
                borderBottomColor={"AVColor.grey"}
              >
                <Text fontSize={24}>
                  {showAddComment
                    ? Loc.currentLang.post.addComment
                    : Loc.currentLang.post.createPost}
                </Text>

                <HStack space={3} alignItems="center">
                  {/* Expand / Collapse Button */}
                  <Tooltip
                    title={
                      isExpanded
                        ? Loc.currentLang.postPopup.collapse
                        : Loc.currentLang.postPopup.expand
                    }
                    style={{ top: "4px", zIndex: 10 }}
                    arrow
                  >
                    <Pressable
                      onPress={() => {
                        setIsExpanded((prev) => !prev);
                        dispatch(setPostPopupExpanded((prev) => !prev));
                      }}
                    >
                      {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
                    </Pressable>
                  </Tooltip>

                  {/* Close Button */}
                  <AVCancel
                    callback={() => {
                      setShowCreatePost(false);
                      dispatch(setPostPopupExpanded(false));
                    }}
                    color={undefined}
                    size={undefined}
                  />
                </HStack>
              </HStack>

              <ScrollView
                showsHorizontalScrollIndicator={false}
                maxHeight={isExpanded ? "78vh" : "45vh"}
              >
                <HStack
                  marginTop={showAddComment ? "25px" : "0px"}
                  space={6}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {/* Who Can View */}
                  {!showAddComment &&
                  !isHuddlePostTab &&
                  visibilityPermission !== "P" ? (
                    <HStack marginTop="30px" space={3} alignItems="center">
                      <Text fontSize={"18"}>
                        {Loc.currentLang.menu.whoCanView} :
                      </Text>
                      <HStack ref={menuRefs}>
                        <HStack>
                          <Button
                            width={"248px"}
                            bgColor={"rgba(0, 166, 188, 0.15)"}
                            rounded="full"
                            fontWeight="550px"
                            color="#fff"
                            justifyContent={"flex-start"}
                            minHeight="40px"
                            marginTop={"-5px"}
                            borderRadius={"20px"}
                            borderColor={"AVColor.primary"}
                            onPress={() => {
                              setIsActive(!isActive);
                            }}
                          >
                            <Text
                              color={"rgba(0, 167, 188, 1)"}
                              font-size={"18px"}
                              lineHeight={"1rem"}
                              paddingLeft={"18px"}
                            >
                              {visibility}
                            </Text>
                          </Button>
                          <Pressable
                            position={"absolute"}
                            right={"12px"}
                            top={"10px"}
                            onPress={() => {
                              setIsActive(!isActive);
                            }}
                          >
                            <DropdownIcon height={"9"} width={"16"} />
                          </Pressable>
                        </HStack>

                        <HStack ref={dropdownRef}>
                          {isActive && (
                            <HStack
                              position={"absolute"}
                              right={0}
                              top={"39px"}
                              flexDirection={"column"}
                              width={"240px"}
                              borderRadius={"5px"}
                              bgColor="#FFFFFF"
                              shadow="9"
                              rounded="lg"
                              zIndex={100}
                            >
                              {(visibilityPermission == "F" ||
                                visibilityPermission == "B") && (
                                <Button
                                  onPress={() => {
                                    setVisibility(Loc.currentLang.menu.private);
                                    setIsActive(!isActive);
                                  }}
                                  bgColor="#FFFFFF"
                                  height="30px"
                                  justifyContent={"start"}
                                  _hover={{
                                    backgroundColor: "AVColor.hovercolor",
                                  }}
                                  width={"240px"}
                                >
                                  <Text
                                    color={"black"}
                                    width={"130px"}
                                    text-overflow={"ellipsis"}
                                    numberOfLines={1}
                                  >
                                    {Loc.currentLang.menu.private}
                                  </Text>
                                </Button>
                              )}

                              {(visibilityPermission == "B" ||
                                Postdata?.id == currentUser?.id ||
                                Postdata == undefined ||
                                isStaffOfEntity) && (
                                <Button
                                  onPress={() => {
                                    setVisibility(Loc.currentLang.menu.public);
                                    setIsActive(!isActive);
                                  }}
                                  bgColor="#FFFFFF"
                                  height="30px"
                                  justifyContent={"start"}
                                  _hover={{
                                    backgroundColor: "AVColor.hovercolor",
                                  }}
                                  width={"240px"}
                                >
                                  <Text
                                    color={"black"}
                                    width={"130px"}
                                    text-overflow={"ellipsis"}
                                    numberOfLines={1}
                                  >
                                    {Loc.currentLang.menu.public}
                                  </Text>
                                </Button>
                              )}

                              {(visibilityPermission == "F" ||
                                visibilityPermission == "B") && (
                                <Button
                                  onPress={() => {
                                    setVisibility(
                                      Loc.currentLang.menu.followers,
                                    );
                                    setIsActive(!isActive);
                                  }}
                                  bgColor="#FFFFFF"
                                  height="30px"
                                  justifyContent={"start"}
                                  _hover={{
                                    backgroundColor: "AVColor.hovercolor",
                                  }}
                                  width={"240px"}
                                >
                                  <Text
                                    color={"black"}
                                    width={"130px"}
                                    text-overflow={"ellipsis"}
                                    numberOfLines={1}
                                  >
                                    {Loc.currentLang.menu.followers}
                                  </Text>
                                </Button>
                              )}

                              {isStaffOfEntity && (
                                <Button
                                  onPress={() => {
                                    setVisibility(
                                      Loc.currentLang.menu.organizations,
                                    );
                                    setIsActive(!isActive);
                                  }}
                                  bgColor="#FFFFFF"
                                  height="30px"
                                  justifyContent={"start"}
                                  _hover={{
                                    backgroundColor: "AVColor.hovercolor",
                                  }}
                                  width={"240px"}
                                >
                                  <Text
                                    color={"black"}
                                    width={"130px"}
                                    text-overflow={"ellipsis"}
                                    numberOfLines={1}
                                  >
                                    {Loc.currentLang.menu.organizations}
                                  </Text>
                                </Button>
                              )}
                            </HStack>
                          )}
                        </HStack>
                      </HStack>
                    </HStack>
                  ) : (
                    <Box width="320px" />
                  )}

                  {/* Right side - Boost Post */}
                  {!showAddComment &&
                    /*isStaffOfEntity || */ isOwnerOfBoost && (
                      <HStack marginTop="30px" space={3} alignItems="center">
                        <Pressable onPress={() => setShowBoostPostPopup(true)}>
                          <HStack alignItems="center" space={2}>
                            <BoostIcon width={"24px"} height={"24px"} />
                            <Text
                              fontSize="20px"
                              color="#00A7BC"
                              textDecorationLine="underline"
                            >
                              {Loc.currentLang.boostPost.boostPost}
                            </Text>
                          </HStack>
                        </Pressable>
                      </HStack>
                    )}
                </HStack>

                <div style={{ position: !isActive ? "relative" : "unset" }}>
                  <Box
                    marginTop={"24px"}
                    height={
                      bgImgHeight
                        ? `${Math.min((parseInt(bgImgHeight, 10) / window.innerHeight) * 100 + 7, 61)}vh`
                        : isExpanded
                          ? "61vh"
                          : "27vh"
                    }
                    maxHeight={isExpanded ? "61vh" : "27vh"}
                    overflowY={useRichText ? "auto" : "unset"}
                    overflowX="hidden"
                    //width={
                    //  useRichText
                    //    ? bgImgWidth
                    //      ? `${parseInt(bgImgWidth, 10)}px`
                    //      : "100%"
                    //    : "unset"
                    //}
                    //maxWidth={useRichText ? "100%" : "unset"}
                    //overflowX={useRichText ? "auto" : "unset"}
                    borderWidth={useRichText ? 0 : 1}
                    borderRadius={useRichText ? 0 : 5}
                    borderColor={"AVColor.grey"}
                    zIndex={isActive ? "-1" : "0"}
                    position="relative"
                  >
                    {useRichText ? (
                      <SunEditor
                        getSunEditorInstance={(editor) => {
                          editorRef.current = editor;
                          //(editor as any).dialogBox.linkBox.submitButton = "Submit";
                          //(editor as any).dialogBox.imageBox.submitButton = "Submit";

                          const editorContainer =
                            document.querySelector(".sun-editor");
                          if (!editorContainer) return;

                          // HARD BLOCK drag & drop
                          const wysiwyg = editor.core.context.element.wysiwyg;
                          if (!wysiwyg) return;

                          ["dragenter", "dragover", "drop"].forEach((event) => {
                            wysiwyg.addEventListener(
                              event,
                              (e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                //if (event === "drop") {
                                //  CustomToast({
                                //    clientError: {
                                //      message: "Drag & drop upload is disabled",
                                //    },
                                //  });
                                //}
                              },
                              true, // capture phase (important)
                            );
                          });

                          // Helper: clear image dialog state
                          const clearImageDialogState = () => {
                            const fileInput = document.querySelector(
                              "._se_image_file",
                            ) as HTMLInputElement | null;

                            if (fileInput) {
                              fileInput.value = "";
                            }

                            const statusText = document.querySelector(
                              ".file-status-text",
                            ) as HTMLElement | null;

                            if (statusText) {
                              statusText.textContent =
                                Loc.currentLang.richText.noFileChosen;
                              statusText.style.color = "#777";
                            }

                            const imageUrlInput = document.querySelector(
                              "._se_image_url",
                            ) as HTMLInputElement | null;

                            if (imageUrlInput) imageUrlInput.value = "";

                            const urlError = document.querySelector(
                              ".image-url-error",
                            ) as HTMLElement | null;

                            if (urlError) urlError.style.display = "none";
                          };

                          // Watch for the Image Insert dialog opening
                          const observer = new MutationObserver(() => {
                            //// Handle proportion checkbox
                            //const proportionCheckbox =
                            //  document.querySelector<HTMLInputElement>(
                            //    "._se_image_check_proportion",
                            //  );
                            //if (
                            //  proportionCheckbox &&
                            //  proportionCheckbox.checked
                            //) {
                            //  autoSetImageSize();
                            //  proportionCheckbox.click(); // uncheck every time dialog opens
                            //}

                            //// Set top for dialogs
                            //const dialog =
                            //  document.querySelector<HTMLDivElement>(
                            //    ".se-dialog-content",
                            //  );
                            //if (dialog) {
                            //  dialog.style.top = isExpanded ? "22%" : "0%";
                            //}

                            // Image dialog
                            const imageDialog = document.querySelector(
                              ".se-dialog-image",
                            ) as HTMLElement | null;

                            if (!imageDialog) return;

                            // Custom File Input validation handling
                            const fileInput = document.querySelector(
                              "._se_image_file",
                            ) as HTMLInputElement;
                            if (
                              fileInput &&
                              !fileInput.parentElement?.querySelector(
                                ".file-status",
                              )
                            ) {
                              // Allow only JPG + PNG + GIF
                              fileInput.accept =
                                "image/jpeg, image/png, image/gif";
                              // Add dashed border style
                              const fileContainer = fileInput.closest(
                                ".se-dialog-form-files",
                              ) as HTMLElement;
                              if (fileContainer) {
                                fileContainer.style.position = "relative";
                                fileContainer.style.border = "2px dashed #ccc";
                                fileContainer.style.borderRadius = "8px";
                                fileContainer.style.padding = "12px";
                                fileContainer.style.textAlign = "center";
                              }

                              // Create wrapper for labels
                              const statusDiv = document.createElement("div");
                              statusDiv.className = "file-status";
                              statusDiv.innerHTML = `
                                <span class="upload-label">${Loc.currentLang.richText.uploadFile}</span>
                                <span class="file-status-text">${Loc.currentLang.richText.noFileChosen}</span>
                              `;
                              fileInput.parentElement?.appendChild(statusDiv);

                              // Handle file change event
                              fileInput.addEventListener(
                                "change",
                                (e: Event) => {
                                  const target = e.target as HTMLInputElement;
                                  const file = target?.files?.[0] || null;
                                  const statusText = statusDiv.querySelector(
                                    ".file-status-text",
                                  ) as HTMLElement;

                                  // Clear Image URL when file is uploaded
                                  const imageUrlInput =
                                    imageDialog.querySelector(
                                      "._se_image_url",
                                    ) as HTMLInputElement | null;

                                  const urlError = imageDialog.querySelector(
                                    ".image-url-error",
                                  ) as HTMLElement | null;

                                  const submitBtn = imageDialog.querySelector(
                                    ".se-btn-primary",
                                  ) as HTMLButtonElement | null;

                                  if (imageUrlInput) imageUrlInput.value = "";
                                  if (urlError) urlError.style.display = "none";
                                  if (submitBtn) submitBtn.disabled = false;

                                  if (file) {
                                    if (
                                      ![
                                        "image/jpeg",
                                        "image/png",
                                        "image/gif",
                                      ].includes(file.type)
                                    ) {
                                      statusText.textContent =
                                        "Only JPEG, PNG and GIF files are allowed";
                                      statusText.style.color = "red";
                                      target.value = ""; // Reset invalid file
                                      return;
                                    }

                                    statusText.textContent = file.name;
                                    statusText.style.color = "#333";
                                  } else {
                                    statusText.textContent =
                                      Loc.currentLang.richText.noFileChosen;
                                    statusText.style.color = "#777";
                                  }
                                },
                              );

                              // Custom Image URL validation handling
                              const imageUrlInput = imageDialog.querySelector(
                                "._se_image_url",
                              ) as HTMLInputElement | null;
                              const submitBtn = imageDialog.querySelector(
                                ".se-btn-primary",
                              ) as HTMLButtonElement | null;

                              if (imageUrlInput && submitBtn) {
                                let errorMsg = imageDialog.querySelector(
                                  ".image-url-error",
                                ) as HTMLElement | null;
                                if (!errorMsg) {
                                  errorMsg = document.createElement("div");
                                  errorMsg.className = "image-url-error";
                                  errorMsg.style.color = "red";
                                  errorMsg.style.fontSize = "12px";
                                  errorMsg.style.marginTop = "6px";
                                  errorMsg.style.display = "none";
                                  imageUrlInput.parentElement?.appendChild(
                                    errorMsg,
                                  );
                                }

                                if (!(imageUrlInput as any)._boundValidation) {
                                  (imageUrlInput as any)._boundValidation =
                                    true;

                                  imageUrlInput.addEventListener(
                                    "input",
                                    () => {
                                      const value = imageUrlInput.value.trim();

                                      if (!value) {
                                        errorMsg!.style.display = "none";
                                        submitBtn.disabled = false;
                                        return;
                                      }

                                      if (!isValidLink.test(value)) {
                                        errorMsg!.textContent =
                                          "Enter a valid image URL";
                                        errorMsg!.style.display = "block";
                                        submitBtn.disabled = true;
                                      } else {
                                        errorMsg!.style.display = "none";
                                        submitBtn.disabled = false;
                                      }
                                    },
                                  );
                                }
                              }

                              // Handle image dialog close
                              const closeBtn = imageDialog.querySelector(
                                'button[data-command="close"]',
                              ) as HTMLButtonElement | null;

                              if (closeBtn && !(closeBtn as any)._boundClear) {
                                (closeBtn as any)._boundClear = true;
                                closeBtn.addEventListener(
                                  "click",
                                  clearImageDialogState,
                                );
                              }

                              // Handle image clear on submit
                              if (
                                submitBtn &&
                                !(submitBtn as any)._boundSubmitClear
                              ) {
                                (submitBtn as any)._boundSubmitClear = true;
                                submitBtn.addEventListener("click", () => {
                                  setTimeout(clearImageDialogState, 300);
                                });
                              }
                            }
                          });

                          // Observe editor container for dialogs being added
                          observer.observe(editorContainer, {
                            childList: true,
                            subtree: true,
                          });
                        }}
                        //lang={customLang}
                        lang={
                          currentUser?.preferences?.lang
                            ? currentUser.preferences.lang === "en-us"
                              ? "en"
                              : currentUser.preferences.lang
                            : "en"
                        }
                        setOptions={{
                          ...toolbarOptions,
                          height: isExpanded ? "54vh" : "20vh",
                        }}
                        onChange={(value) => {
                          if (showAddComment) {
                            handleAddComment(
                              value,
                              showAddComment,
                              useRichText,
                            );
                          }
                          setRteValue(value);
                          setAlertMessage("");
                        }}
                        setContents={rteValue}
                        autoFocus={true}
                      />
                    ) : (
                      <textarea
                        ref={textRef}
                        value={text}
                        style={{
                          border: "none",
                          resize: "none",
                          height: isExpanded ? "55vh" : "20vh",
                          padding: "20px 15px",
                          outline: "none",
                          fontFamily: "inherit",
                          fontSize: "inherit",
                          borderColor: "rgba(0, 0, 0, 0.25)",
                        }}
                        placeholder={
                          Loc.currentLang.post?.createPostPlaceholder ||
                          Loc.currentLang.postPopup.shareWhatIsOnYourMind
                        }
                        onChange={(e) => {
                          if (showAddComment) {
                            handleAddComment(
                              e.target.value,
                              showAddComment,
                              useRichText,
                            );
                          }
                          setText(e.target.value);
                          setAlertMessage("");
                        }}
                        onKeyDown={async (e) => {
                          if (
                            e.key === "Enter" &&
                            !e.shiftKey &&
                            !isMobile &&
                            !isLoading &&
                            !isImageProcessing
                          ) {
                            e.preventDefault();
                            if (showAddComment) {
                              setIsLoading(true);
                              try {
                                await handlePostComment(useRichText);
                              } finally {
                                setIsLoading(false);
                                setShowAddComment(false);
                              }
                            } else {
                              handlePublish();
                            }
                          }
                        }}
                        autoFocus
                      />
                    )}

                    {/* Right-side Buttons (Top editor tool options Background Controls) */}
                    {useRichText && (
                      <div
                        style={{
                          position: "absolute",
                          //right: isExpanded ? "calc(100% - 685px)" : "10px",
                          right: isExpanded ? "calc(100% - 655px)" : "45px",
                          top: "5px",
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          border: "1px solid #dadada",
                          borderRadius: "4px",
                          //padding: isExpanded ? "4px 6px" : "4px 5px",
                          padding: "8px 8px",
                          zIndex: 10,
                        }}
                      >
                        {/* Background Color Picker */}
                        <Box
                          position="relative"
                          display="inline-block"
                          //top="3px"
                        >
                          <Tooltip
                            title={Loc.currentLang.postPopup.backgroundColor}
                            arrow
                          >
                            <Pressable
                              onPress={() =>
                                setShowColorPicker(!showColorPicker)
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <BrushIcon height="20" width="20" color="black" />
                            </Pressable>
                          </Tooltip>

                          {/* Color picker popup */}
                          {showColorPicker && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: isExpanded ? "40px" : "auto",
                                top: "40px",
                                right: "20px",
                                zIndex: 9999,
                                maxHeight: isExpanded ? "auto" : "150px",
                                overflowY: isExpanded ? "visible" : "auto",
                              }}
                              ref={colorPickerRef}
                            >
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                              >
                                {/* Color Picker */}
                                <SketchPicker
                                  color={bgColor}
                                  onChange={handleColorChange}
                                />

                                {/* Remove background color */}
                                {bgColor && (
                                  <Tooltip
                                    title={
                                      Loc.currentLang.postPopup
                                        .removeBackgroundColor
                                    }
                                    arrow
                                  >
                                    <Pressable
                                      alignSelf="flex-end"
                                      top="-25px"
                                      left="-14px"
                                      onPress={() => {
                                        setBgColor("");
                                        const editableArea =
                                          document.querySelector<HTMLDivElement>(
                                            ".sun-editor-editable",
                                          );
                                        if (editableArea)
                                          editableArea.style.backgroundColor =
                                            "unset";
                                        setShowColorPicker(false);
                                      }}
                                    >
                                      <CircleSlashIcon
                                        width={"14px"}
                                        height={"14px"}
                                      />
                                    </Pressable>
                                  </Tooltip>
                                )}
                              </Box>
                            </div>
                          )}
                        </Box>

                        {/* Background Image Upload + Add/Remove Menu */}
                        {/*<Box position="relative" display="inline-block">*/}
                        {/*  <input*/}
                        {/*    type="file"*/}
                        {/*    accept="image/*"*/}
                        {/*    ref={(el) => (fileInputRef.current = el)}*/}
                        {/*    onChange={async (e) => {*/}
                        {/*      const file = e.target.files?.[0];*/}
                        {/*      if (!file) return;*/}

                        {/*      const fileList = createFileList([file]);*/}
                        {/*      if (!fileList) return;*/}

                        {/*      try {*/}
                        {/*        const data = await AV.Media.saveFiles(*/}
                        {/*          AV.Media.getFormData(fileList),*/}
                        {/*          currentUser?.region,*/}
                        {/*        );*/}

                        {/*        setBgColor("");*/}
                        {/*        const srclink = AV.Media.getURL(data[0]);*/}
                        {/*        setBgImage(srclink);*/}

                        {/*        const editableArea =*/}
                        {/*          document.querySelector<HTMLDivElement>(*/}
                        {/*            ".sun-editor-editable",*/}
                        {/*          );*/}
                        {/*        if (editableArea) {*/}
                        {/*          // Create an image object to get its natural width and height*/}
                        {/*          const img = document.createElement(*/}
                        {/*            "img",*/}
                        {/*          ) as HTMLImageElement;*/}
                        {/*          img.src = srclink;*/}

                        {/*          img.onload = () => {*/}
                        {/*            const imgWidth = img.naturalWidth;*/}
                        {/*            const imgHeight = img.naturalHeight;*/}
                        {/*            setBgImgWidth(imgWidth.toString());*/}
                        {/*            setBgImgHeight(imgHeight.toString());*/}

                        {/*            // Set editor background*/}
                        {/*            editableArea.style.backgroundColor =*/}
                        {/*              "unset";*/}
                        {/*            editableArea.style.backgroundImage = `url(${srclink})`;*/}
                        {/*            editableArea.style.backgroundSize =*/}
                        {/*              "contain";*/}
                        {/*            editableArea.style.backgroundPosition =*/}
                        {/*              "left";*/}
                        {/*            editableArea.style.backgroundRepeat =*/}
                        {/*              "no-repeat";*/}

                        {/*            // Set editor height to image height or scale as needed*/}
                        {/*            editableArea.style.height = `${imgHeight}px`;*/}
                        {/*            editableArea.style.minHeight = `${imgHeight}px`;*/}
                        {/*            editableArea.style.width = `${imgWidth}px`;*/}
                        {/*            editableArea.style.minWidth = `${imgWidth}px`;*/}
                        {/*          };*/}
                        {/*        }*/}
                        {/*      } catch (err) {*/}
                        {/*        console.error(*/}
                        {/*          "Background image upload failed:",*/}
                        {/*          err,*/}
                        {/*        );*/}
                        {/*      }*/}
                        {/*    }}*/}
                        {/*    style={{ display: "none" }}*/}
                        {/*  />*/}

                        {/*  */}
                        {/* Background Image Options */}
                        {/*  <Tooltip title={Loc.currentLang.postPopup.backgroundImage} arrow>*/}
                        {/*    <Pressable*/}
                        {/*      onPress={() => {*/}
                        {/*        if (bgImage) setShowBgImgMenu(!showBgImgMenu);*/}
                        {/*        else fileInputRef.current?.click();*/}
                        {/*      }}*/}
                        {/*      style={{*/}
                        {/*        display: "flex",*/}
                        {/*        alignItems: "center",*/}
                        {/*        justifyContent: "center",*/}
                        {/*      }}*/}
                        {/*    >*/}
                        {/*      <ImportBGImage*/}
                        {/*        height="28"*/}
                        {/*        width="28"*/}
                        {/*        color="black"*/}
                        {/*      />*/}
                        {/*    </Pressable>*/}
                        {/*  </Tooltip>*/}

                        {/*  */}
                        {/* Menu List for Add/Remove */}
                        {/*  {showBgImgMenu && (*/}
                        {/*    <Box*/}
                        {/*      ref={bgImgMenuRef}*/}
                        {/*      position="absolute"*/}
                        {/*      top="40px"*/}
                        {/*      right="0"*/}
                        {/*      bg="white"*/}
                        {/*      borderWidth="1px"*/}
                        {/*      borderColor="#ddd"*/}
                        {/*      borderRadius="8px"*/}
                        {/*      shadow={3}*/}
                        {/*      zIndex={9999}*/}
                        {/*      p="2px"*/}
                        {/*      minW="70px"*/}
                        {/*    >*/}
                        {/*      <Pressable*/}
                        {/*        onPress={() => {*/}
                        {/*          fileInputRef.current?.click();*/}
                        {/*          setShowBgImgMenu(false);*/}
                        {/*        }}*/}
                        {/*      >*/}
                        {/*        <Box px={3} py={2}>*/}
                        {/*          <Text fontSize="14px">Add</Text>*/}
                        {/*        </Box>*/}
                        {/*      </Pressable>*/}

                        {/*      <Pressable*/}
                        {/*        onPress={() => {*/}
                        {/*          setBgImage("");*/}
                        {/*          setBgImgWidth("");*/}
                        {/*          setBgImgHeight("");*/}

                        {/*          const editableArea =*/}
                        {/*            document.querySelector<HTMLDivElement>(*/}
                        {/*              ".sun-editor-editable",*/}
                        {/*            );*/}
                        {/*          if (editableArea) {*/}
                        {/*            editableArea.style.backgroundImage =*/}
                        {/*              "unset";*/}
                        {/*            editableArea.style.backgroundSize = "unset";*/}
                        {/*            editableArea.style.backgroundPosition =*/}
                        {/*              "unset";*/}
                        {/*            editableArea.style.backgroundRepeat =*/}
                        {/*              "unset";*/}

                        {/*            editableArea.style.height = isExpanded*/}
                        {/*              ? "54vh"*/}
                        {/*              : "20vh";*/}
                        {/*            editableArea.style.minHeight = isExpanded*/}
                        {/*              ? "54vh"*/}
                        {/*              : "20vh";*/}
                        {/*            editableArea.style.width = "unset";*/}
                        {/*            editableArea.style.minWidth = "unset";*/}
                        {/*          }*/}

                        {/*          setShowBgImgMenu(false);*/}
                        {/*        }}*/}
                        {/*      >*/}
                        {/*        <Box px={3} py={2}>*/}
                        {/*          <Text fontSize="14px" color="red.500">*/}
                        {/*            Remove*/}
                        {/*          </Text>*/}
                        {/*        </Box>*/}
                        {/*      </Pressable>*/}
                        {/*    </Box>*/}
                        {/*  )}*/}
                        {/*</Box>*/}
                      </div>
                    )}

                    {/* Right-side Buttons (Bottom Formatting + Emoji) */}
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        bottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        zIndex: 10,
                      }}
                    >
                      {/* Formatting Icon */}
                      <Tooltip
                        title={
                          useRichText
                            ? Loc.currentLang.postPopup.plainPost
                            : Loc.currentLang.postPopup.formattingPost
                        }
                        style={{
                          top: "3px",
                          zIndex: 10,
                        }}
                        arrow
                      >
                        <Pressable
                          //onPress={() =>
                          //  setUseRichText((prev) => {
                          //    const newValue = !prev;
                          //    if (newValue) setText("");
                          //    else setRteValue("");
                          //    return newValue;
                          //  })
                          //}
                          onPress={handleToggleRichTextPost}
                        >
                          {useRichText ? <PlainTextIcon /> : <FormattingIcon />}
                        </Pressable>
                      </Tooltip>

                      {/* Emoji Icon */}
                      <AVEmoji showEmoji={() => setPicker((prev) => !prev)} />
                    </div>
                  </Box>
                </div>

                <HStack
                  my={3}
                  justifyContent={"center"}
                  width={isExpanded ? (mobile ? "100%" : "85%") : "85%"}
                  //height={isExpanded ? (mobile ? "200px" : "250px") : "auto"}
                  space={4}
                  alignItems={"center"}
                  alignSelf={"center"}
                  zIndex={useRichText ? "-3" : "0"}
                >
                  <CreatePostGrid
                    setLinks={setLink}
                    links={link}
                    images={Img}
                    setImages={setImg}
                    setvideos={setvio}
                    allMedia={allMedia}
                    setAllMedia={setAllMedia}
                    videos={video}
                    setOneDriveLink={setOneDriveLink}
                    oneDriveLink={oneDriveLink}
                    setMedia={setMedia}
                    media={media}
                    pdf={pdf}
                    setpdf={setpdf}
                    setShowPreview={setShowPreview}
                    setSingleImage={setSingleImage}
                    setShowAllImage={setShowAllImage}
                    setIsLoading={setIsLoading}
                    selectedItem={selectedItem}
                    setIsConfirmDelete={setIsConfirmDelete}
                    handleConfirmDelete={handleConfirmDelete}
                  />
                </HStack>
              </ScrollView>

              {(alertMessage || successMessage) && (
                <HStack alignItems={"center"} justifyContent={"center"}>
                  <Text
                    fontSize={16}
                    color={alertMessage ? "danger.600" : "success.600"}
                  >
                    {alertMessage || successMessage}
                  </Text>
                </HStack>
              )}

              {isOpenBox && (
                <ExternalLink
                  setIsOpenBox={setIsOpenBox}
                  setIsOneDriveData={setIsOneDriveData}
                  setIsYouTube={setIsYouTube}
                  setIsOpenCemera={setIsOpenCemera}
                  setCameraMode={setCameraMode}
                  imageInputRef={imageInputRef}
                  menuRefs={menuRefs}
                  handleOpenPicker={handleOpenPicker}
                  setExternalLink={setExternalLink}
                  HandleAddOneDrive={HandleAddOneDrive}
                  setShowExternalLinkInput={setShowExternalLinkInput}
                  showExternalLinkInput={showExternalLinkInput}
                  HandleAddDropBoxLink={HandleAddDropBoxLink}
                />
              )}

              <input
                type="file"
                accept="image/jpeg,image/jfif,image/png,image/gif,video/mp4,"
                //accept="image/jpeg,image/jfif,image/png,image/webp,image/gif,video/mp4,"
                multiple
                hidden
                ref={imageInputRef}
                onChange={handleImages}
              />

              {/* AddToYourPost, Cancel & Publish Buttons */}
              <Box
                //py={2}
                //px={4}
                //mt={"-20px"}
                position="relative"
                //bgColor={isExpanded ? "white" : "transparent"}
                zIndex={10}
              >
                <HStack
                  justifyContent="space-between"
                  alignItems="center"
                  w="100%"
                >
                  {/*Left: Add to Post */}
                  <HStack alignItems="center" space={3}>
                    <Pressable
                      position={"relative"}
                      bottom={0}
                      onPress={() => {
                        setIsOpenBox(!isOpenBox);
                        const closeBtn = document.querySelector(
                          ".se-btn.se-dialog-close",
                        ) as HTMLElement | null;
                        closeBtn?.click();
                      }}
                      _hover={{ bgColor: "gray.100" }}
                      borderRadius={"10px"}
                      margin={"3px"}
                    >
                      <HStack space={3}>
                        <Button
                          padding={"15px"}
                          rounded={"full"}
                          _hover={{
                            opacity: 0.8,
                          }}
                          onPress={() => {
                            setIsOpenBox(!isOpenBox);
                            const closeBtn = document.querySelector(
                              ".se-btn.se-dialog-close",
                            ) as HTMLElement | null;
                            closeBtn?.click();
                          }}
                          backgroundColor={"AVColor.primary"}
                        >
                          {!isOpenBox ? (
                            <AddIcon size={"15px"} color="AVColor.white" />
                          ) : (
                            <CloseIcon size={"15px"} color="AVColor.white" />
                          )}
                        </Button>
                        {!mobile && (
                          <Text
                            alignSelf={"center"}
                            fontSize={"18px"}
                            fontWeight={400}
                          >
                            {Loc.currentLang.post.addToYourPost}
                          </Text>
                        )}
                      </HStack>
                    </Pressable>
                  </HStack>

                  {/*  Right: Footer Buttons */}
                  <HStack space={3}>
                    <Button
                      height={"40px"}
                      width={"180px"}
                      backgroundColor={" rgba(238, 238, 238, 1)"}
                      borderRadius={"full"}
                      onPress={() => {
                        setShowCreatePost(false);
                        dispatch(setPostPopupExpanded(false));
                      }}
                    >
                      <Text
                        fontWeight={400}
                        color={"rgba(0, 0, 0, 0.5)"}
                        fontSize={"16px"}
                      >
                        {Loc.currentLang.menu.cancel}
                      </Text>
                    </Button>

                    <Button
                      height={"40px"}
                      width={"180px"}
                      backgroundColor={"AVColor.primary"}
                      borderRadius={"full"}
                      onPress={async () => {
                        if (showAddComment) {
                          setIsLoading(true);
                          try {
                            await handlePostComment(useRichText);
                          } finally {
                            setIsLoading(false);
                            setShowAddComment(false);
                          }
                        } else {
                          handlePublish();
                        }
                      }}
                      isDisabled={
                        (!useRichText &&
                          text?.trim().length === 0 &&
                          (!media || media.length === 0)) ||
                        (useRichText &&
                          !hasContent(rteValue) &&
                          (!media || media.length === 0))
                      }
                      isLoading={isLoading || isImageProcessing}
                      isLoadingText={
                        isImageProcessing
                          ? Loc.currentLang.post.processing
                          : Loc.currentLang.post.publishing
                      }
                    >
                      <Text color={"white"} fontWeight={400} fontSize={"16px"}>
                        {Loc.currentLang.menu.publish}
                      </Text>
                    </Button>
                  </HStack>
                </HStack>
              </Box>
            </VStack>
          </div>
        </Box>
      )}

      {showExternalLinkInput && !isOpenCemera && (
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              isMobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isMobile ? dimensions.width - 15 : "565px",
              height: isMobile ? "650px" : "240px",
              marginTop: "12px",
            }}
          >
            <VStack width={"100%"} padding={"24px"}>
              <HStack
                justifyContent={"space-between"}
                width={"100%"}
                alignItems={"center"}
                marginTop={"20px"}
                borderBottomColor={"AVColor.grey"}
              >
                <Text fontSize={"24px"}>
                  {isYoutube
                    ? "Add Youtube Url"
                    : Loc.currentLang.postPopup.addPostUrl}
                </Text>
                <AVCancel
                  callback={() => {
                    setShowExternalLinkInput(false);
                  }}
                  color={undefined}
                  size={undefined}
                />
              </HStack>
              <HStack width={"100%"} marginTop={"24px"}>
                <Box width={"95%"} justifyContent="center">
                  <AVInputtext
                    type={"text"}
                    label={
                      isYoutube
                        ? Loc.currentLang.menu.addYoutubeUrl
                        : Loc.currentLang.postPopup.addPostUrl
                    }
                    onChange={handleExternalLink}
                    maxLength={undefined}
                    defaultValue={undefined}
                    width={undefined}
                    value={externalLink}
                    height={"20px"}
                    minRows={undefined}
                    multiline={undefined}
                    size={undefined}
                    placeholder={undefined}
                  />
                </Box>
              </HStack>
              <HStack
                justifyContent={"center"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"180px"}
                  height={"40px"}
                  backgroundColor={"AVColor.primary"}
                  rounded={"full"}
                  isDisabled={externalLink?.trim().length === 0}
                  isLoading={addLinkLoad}
                  onPress={() => HandleAddExternalUrl()}
                >
                  <Text fontWeight={500} color={"white"}>
                    {Loc.currentLang.menu.ok}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isOpenCemera && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px" // horizontal padding for small screens
        >
          <Box
            bg="white"
            borderRadius="12px"
            p="20px"
            w="100%"
            maxW="750px"
            maxH="95vh"
            overflowY="auto"
          >
            <VStack space={4}>
              {/* Webcam preview */}
              <Box w="100%" position="relative">
                <Webcam
                  audio={cameraMode === "video"}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ facingMode: "user" }}
                  style={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                {/* Timer Overlay */}
                {cameraMode === "video" && recording && (
                  <Box
                    position="absolute"
                    top="12px"
                    right="16px"
                    px="8px"
                    py="4px"
                    backgroundColor="rgba(0,0,0,0.6)"
                    borderRadius="md"
                  >
                    <Text color="white" fontWeight="bold" fontSize="md">
                      ⏺ {formatDuration(duration)}
                    </Text>
                  </Box>
                )}
              </Box>

              {/* Buttons */}
              <HStack
                flexWrap="wrap"
                justifyContent="flex-end"
                space={3}
                mt="20px"
                zIndex={100000}
              >
                {/* Toggle Camera Mode */}
                {/*<IconButton*/}
                {/*  icon={*/}
                {/*    cameraMode === "photo" ? (*/}
                {/*      <FiCamera size={20} color="#000" />*/}
                {/*    ) : (*/}
                {/*      <FiVideo size={20} color="#000" />*/}
                {/*    )*/}
                {/*  }*/}
                {/*  borderRadius="full"*/}
                {/*  backgroundColor="rgba(238, 238, 238, 1)"*/}
                {/*  onPress={toggleMode}*/}
                {/*  aria-label="Toggle Mode"*/}
                {/*/>*/}

                <div
                  className="toggleContainer"
                  style={{ display: "none" /*"flex"*/, gap: "12px" }}
                >
                  <div
                    className={`iconBox ${cameraMode === "photo" ? "active" : "inactive"}`}
                    onClick={() => toggleMode()}
                  >
                    <FiCamera size={24} />
                  </div>
                  <div
                    className={`iconBox ${cameraMode === "video" ? "active" : "inactive"}`}
                    onClick={() => toggleMode()}
                  >
                    <FiVideo size={24} />
                  </div>
                </div>

                {/* Cancel Button */}
                <Button
                  height="40px"
                  minW="120px"
                  backgroundColor="rgba(238, 238, 238, 1)"
                  borderRadius="full"
                  onPress={() => {
                    if (recording) {
                      isCancelledRef.current = true;
                      handleStopRecording();
                    }
                    onClose();
                  }}
                >
                  <Text
                    color="rgba(0, 0, 0, 0.5)"
                    fontSize="16px"
                    fontWeight={400}
                  >
                    {Loc.currentLang.postPopup.cancel}
                  </Text>
                </Button>

                {/* Capture / Record Button */}
                {cameraMode === "photo" ? (
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor="AVColor.primary"
                    borderRadius="full"
                    isLoading={isImageProcessing}
                    onPress={handleCameraPhotoCapture}
                    isDisabled={!isCameraAccessible}
                  >
                    <Text color="white" fontSize="16px" fontWeight={400}>
                      {Loc.currentLang.postPopup.capture}
                    </Text>
                  </Button>
                ) : (
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor={recording ? "red.500" : "AVColor.primary"}
                    borderRadius="full"
                    isDisabled={!isCameraAccessible}
                    onPress={() => {
                      if (recording) {
                        isCancelledRef.current = false;
                        handleStopRecording();
                      } else {
                        handleStartRecording();
                      }
                    }}
                  >
                    <Text color="white" fontSize="16px" fontWeight={400}>
                      {recording
                        ? Loc.currentLang.postPopup.stop
                        : Loc.currentLang.postPopup.record}
                    </Text>
                  </Button>
                )}
              </HStack>
            </VStack>
          </Box>
        </Box>
      )}

      {showBoostPostPopup && (
        <AVBoostPostPopup
          entity={
            showAddComment
              ? Postdata?.type === "Person"
                ? currentUser
                : //: Postdata?.type === "Event"
                  //  ? Postdata?.parent
                  (Postdata ?? currentUser)
              : //: Postdata?.type === "Event"
                //  ? Postdata?.parent
                (Postdata ?? currentUser)
          }
          paySend={paySend}
          setPaySend={setPaySend}
          subject={subject}
          setSubject={setSubject}
          estimate={estimate}
          setEstimate={setEstimate}
          showBoostPostPopup={showBoostPostPopup}
          setShowBoostPostPopup={setShowBoostPostPopup}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          boostPostOwner={boostPostOwner}
          visibility={estimateVisibility || visibility}
          postContent={
            useRichText
              ? rteValue?.trim()
              : textRef?.current?.value?.trim() || null
          }
          sharedPlan={sharedPlan}
          setSharedPlan={setSharedPlan}
          handleToggleRichTextPost={handleToggleRichTextPost}
          handleToggleRichTextSubject={handleToggleRichTextSubject}
        />
      )}

      {showCreditsPopup && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px"
        >
          <PurchaseCreditsPopup
            entity={
              showAddComment
                ? Postdata?.type === "Person"
                  ? currentUser
                  : Postdata?.type === "Event" ||
                      Postdata?.type === "Game" ||
                      Postdata?.type === "Channel"
                    ? Postdata?.parent
                    : (Postdata ?? currentUser)
                : Postdata?.type === "Event" ||
                    Postdata?.type === "Game" ||
                    Postdata?.type === "Channel"
                  ? Postdata?.parent
                  : (Postdata ?? currentUser)
            }
            sharedPlan={sharedPlan}
            setSharedPlan={setSharedPlan}
            boostPostOwner={boostPostOwner}
            showCreditsPopup={showCreditsPopup}
            setShowCreditsPopup={setShowCreditsPopup}
          />
        </Box>
      )}

      {isConfirmDelete && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px"
        >
          <AVConfirmationModal
            showconfirmationPopup={isConfirmDelete}
            setshowconfirmationPopup={setIsConfirmDelete}
            Confirmationtext={confirmationText}
            type={selectedType}
            item={selectedItem}
            function={handleCancelImage}
            isLoader={isLoading}
          />
        </Box>
      )}
    </>
  );
};

export default AVPostPopup;
